import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useStarterPackMixins, useStarterPackRewardCreationModal } from '@/modules/starter/pack/model/mixins';
import { decorateReward, useStarterPackReward } from '@/modules/starter/pack/reward/model/mixins';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { starterPackService } from '@/services/starter';
import { computed, onMounted } from 'vue';

export function useStarterPackDetail() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model, v$, fetch, iapOptions } = useStarterPackMixins();
    const { fetchLinkableRewards, linkableRewards } = useStarterPackReward();
    const rewardCreationModal = useStarterPackRewardCreationModal();

    const rewardDetailtList = computed(() =>
        model.rewards.map(reward => decorateReward(reward, linkableRewards.value))
    );

    const actions = {
        enable: crudAction.confirmAndEnable({
            request: () => starterPackService.enable(model.id),
            onSuccess: fetch
        }),
        disable: crudAction.confirmAndDisable({
            request: () => starterPackService.disable(model.id),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => starterPackService.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_STARTER.PACK.INDEX })
        }),

        removeReward: crudAction.confirmAndRemove({
            confirmMessage: 'Are you sure you want to remove this reward?',
            request: starterPackService.reward.remove,
            onSuccess: fetch
        }),
        createReward: async () => {
            const { code } = await rewardCreationModal.rewardActions.quickCreate(model.id);
            if (code === ResponseCode.Ok) {
                rewardCreationModal.rewardActions.closeModal();
                fetch();
            }
        }
    };

    onMounted(async () => {
        await fetchLinkableRewards();
        await rewardCreationModal.beforeFetch();
    });

    return { model, v$, rewardDetailtList, actions, iapOptions, rewardCreationModal };
}
